<template>
  <section class="form-surface login-surface">
    <header class="login-page-heading">
      <h1>{{ session.knowledgeBaseTitle }}</h1>
      <p>Sign in to browse projects and edit documents.</p>
    </header>
    <form class="form-panel" @submit.prevent="login">
      <div v-if="message" class="workspace-alert">{{ message }}</div>
      <label class="form-row">
        <span>Email</span>
        <input v-model="email" type="email" autocomplete="email" />
      </label>
      <label class="form-row">
        <span>Password</span>
        <input v-model="password" type="password" autocomplete="current-password" />
      </label>
      <button type="submit" :disabled="submitting">{{ submitting ? 'Logging in' : 'Log in' }}</button>
      <div class="form-actions muted-actions">
        <RouterLink v-if="session.userRegistrationEnabled" class="app-link" to="/register">Register</RouterLink>
        <RouterLink class="app-link" to="/forgot-password">Forgot password?</RouterLink>
      </div>
    </form>
  </section>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { RouterLink, useRoute, useRouter } from 'vue-router';
import { CommandsService } from '../api/generated';
import { getErrorMessage, useSessionStore } from '../stores/session';

const session = useSessionStore();
const route = useRoute();
const router = useRouter();
const email = ref('');
const password = ref('');
const message = ref<string | null>(null);
const submitting = ref(false);

async function login(): Promise<void> {
  if (submitting.value) {
    return;
  }

  submitting.value = true;
  message.value = null;
  try {
    const result = await CommandsService.commandLoginCommand({
      requestBody: {
        email: email.value,
        password: password.value
      }
    });
    await session.refreshAfterLogin(result.requestToken ?? null);
    const returnUrl = typeof route.query.returnUrl === 'string' ? route.query.returnUrl : '/';
    await router.push(returnUrl.startsWith('/') && !returnUrl.startsWith('//') ? returnUrl : '/');
  } catch (error) {
    message.value = getErrorMessage(error, 'Invalid email or password.');
  } finally {
    submitting.value = false;
  }
}
</script>
